// Imports


// Plugins
const plugins = [{
  location: "/Users/lukas.david/Source/my_projects/havelweb/node_modules/react-static-plugin-styled-components",
  plugins: [],
  hooks: {}
},
{
  location: "/Users/lukas.david/Source/my_projects/havelweb",
  plugins: [],
  hooks: {}
}]

// Export em!
export default plugins